
























































































































import { Component, Vue } from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import BTableColumn from 'buefy/src/components/table/TableColumn.vue';
import { Paths } from '@/router';
import {AtmsService, IAtm} from '@/services/AtmsService';
import ConfirmationModal from '@/views/ConfirmationModal.vue';

@Component({
    components: {BTableColumn, BButton},
})
export default class Atms extends Vue {
    private totalItems: number = 0;
    private atms: IAtm[] = [];
    private currentPageNumber: number = 1;

    private nrAtmsPerPage: number = 10;
    private loading: boolean = false;

    private async onPageChange(page: number) {
        this.currentPageNumber = page;
        await this.refresh();
    }

    private async refresh() {
        this.loading = true;

        const page = await AtmsService.getAtms(this.currentPageNumber, this.nrAtmsPerPage);
        this.atms = page.data;
        this.totalItems = page.totalItems;

        this.loading = false;
    }

    private async created() {
        this.loading = true;

        await this.refresh();
    }

    private async deleteAtm(id: number) {
        this.$modal.open({
            parent: this,
            component: ConfirmationModal,
            hasModalCard: true,
            canCancel: false,
            events: {
                confirmed: async () => {
                    try {
                        await AtmsService.deleteAtm(id);
                        await this.refresh();
                    } catch (err) {
                        console.error('Error while deleting an atm!', err);
                    }
                },
            },
        });
    }

    private newAtm() {
        this.$router.push({name: Paths.NEW_ATM});
        return;
    }
}
